import { Welcome } from "./pages/welcome";
import { ResultAssesments } from "./pages/resultAssesments";
import { AssessmentPage } from "./pages/assessmentPage";

export const assessmentRoutes = [
  {
    path: "/assessments/welcome/:id",
    Component: Welcome,
    exact: true,
    isPrivate: false,
  },
  {
    path: "/assessments/questions/:id",
    Component: AssessmentPage,
    exact: true,
    isPrivate: false,
  },
  {
    path: "/assessments/finish/:id",
    Component: ResultAssesments,
    exact: true,
    isPrivate: false,
  },
];
